export function QSCCandidate() {
  this.fObj = null;
  this.fSubCount = null;
}
